export default __webpack_public_path__ + "static/media/appiocn.4c0dbf3d.png";